import { PureComponent } from 'react';
import {
  deleteCA,
  fetchCertificationAuthorities,
  patchCA,
  showUpload,
} from './actions';

import { date } from '@ipfabric/utils';
import { Button } from 'components/Button/Button';
import { ConfirmDialog } from 'containers/ConfirmDialog/ConfirmDialog';
import { toggleConfirmDialog } from 'containers/ConfirmDialog/actions';
import FileUploadOverlay from 'containers/FileUploadOverlay';
import { uploadCA } from 'containers/FileUploadOverlay/actions';
import LTEBox from 'containers/LTEBox';
import { showWarning } from 'containers/Toaster/actions';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { createStructuredSelector } from 'reselect';
import fetch from 'utils/fetch';
import handleEvent from 'utils/handleEvent';
import { withAppProps } from 'utils/react/withAppProps';
import { connectAsAny } from 'utils/redux/connectAsAny';
import { confirmDeleteCA } from './constants';

@fetch({ actions: [fetchCertificationAuthorities] })
@withAppProps
class CertificationAuthorities extends PureComponent {
  static propTypes = {
    ca: ImmutablePropTypes.record,
    dateTimeFormat: PropTypes.string.isRequired,
    timezone: PropTypes.string.isRequired,
    msg: PropTypes.object,
    onDeleteCA: PropTypes.func.isRequired,
    onPatchCA: PropTypes.func.isRequired,
    onShowUpload: PropTypes.func.isRequired,
    onShowWarning: PropTypes.func.isRequired,
    onToggleConfirmDialog: PropTypes.func.isRequired,
    onUploadCA: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      deleteId: null,
      editId: null,
      newName: null,
    };
  }

  onDeleteClick = (id) => (e) => {
    e.preventDefault();
    const { onToggleConfirmDialog } = this.props;
    this.setState({ deleteId: id }, () => onToggleConfirmDialog());
  };

  onEditClick = (id, name) => (e) => {
    e.preventDefault();
    this.setState({ editId: id, newName: name });
  };

  onSaveClick = handleEvent((e) => {
    e.preventDefault();
    const {
      onShowWarning,
      msg: { settingsSystemCertificationAuthrorities: msg },
    } = this.props;
    const { editId, newName } = this.state;
    if (!newName || newName.trim().length === 0) {
      return onShowWarning({
        message: get(msg, 'fillName', "Name can't be empty"),
      });
    }
    const { onPatchCA } = this.props;
    return this.setState({ editId: null, newName: null }, () =>
      onPatchCA({ id: editId, name: newName }),
    );
  });

  handleDeleteClick = handleEvent(() => {
    const { deleteId } = this.state;
    const { onDeleteCA } = this.props;
    this.setState({ deleteId: null }, () => onDeleteCA(deleteId));
  });

  handleShowUploadFile = handleEvent(() => {
    this.props.onShowUpload(true);
  });

  handleCancelUpload = handleEvent(() => {
    this.props.onShowUpload(false);
  });

  handleUpload = handleEvent((fileUploadName, fileUpload) => {
    this.props.onUploadCA({
      data: {
        content: fileUpload,
        name: fileUploadName,
      },
    });
  });

  handleNameChange = handleEvent((e) => {
    this.setState({ newName: e.target.value });
  });

  renderEditBtn = (ca) => {
    const { editId } = this.state;
    if (editId && editId === ca.id) {
      return (
        <Button
          variant='tertiary'
          icon='fa-floppy-disk'
          onClick={this.onSaveClick}
          type='button'
        />
      );
    }
    return (
      <Button
        variant='tertiary'
        icon='fa-pen'
        onClick={this.onEditClick(ca.id, ca.name)}
        type='button'
      />
    );
  };

  renderName = ({ name, id }) => {
    const { editId, newName } = this.state;
    if (editId && editId === id) {
      return (
        <input
          className='form-control'
          key={id}
          type='text'
          onChange={this.handleNameChange}
          // ref={c => { this.editInput = c; }}
          value={newName}
        />
      );
    }
    return name;
  };

  renderCA = () => {
    const {
      ca: { data },
      msg: { settingsSystemCertificationAuthrorities: msg },
      dateTimeFormat,
      timezone,
    } = this.props;
    return (
      <table className='table-striped table-hover table'>
        <thead>
          <tr>
            <th>{get(msg, 'columns.name', 'Name')}</th>
            <th>{get(msg, 'columns.issuedAt', 'Issued')}</th>
            <th>{get(msg, 'columns.expiresAt', 'Expires')}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.map((ca) => {
            return (
              <tr key={ca.id}>
                <td>{this.renderName(ca)}</td>
                <td>
                  {date.formatUtcTimestampInTimeZone(
                    ca.issuedAt,
                    timezone,
                    dateTimeFormat,
                  )}
                </td>
                <td>
                  {date.formatUtcTimestampInTimeZone(
                    ca.expiresAt,
                    timezone,
                    dateTimeFormat,
                  )}
                </td>
                <th>
                  {get(ca, 'custom', false) === true && (
                    <>
                      <Button
                        variant='tertiary'
                        icon='fa-trash-can'
                        onClick={this.onDeleteClick(ca.id)}
                        type='button'
                      />
                      {this.renderEditBtn(ca)}
                    </>
                  )}
                </th>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  render() {
    const {
      msg: { settingsSystemCertificationAuthrorities: msg },
      ca: { showFileUpload },
    } = this.props;
    return (
      <div className='m-4'>
        <Helmet title={msg.pageTitle} />
        {showFileUpload ? (
          <FileUploadOverlay
            onClose={this.handleCancelUpload}
            onUpload={this.handleUpload}
          />
        ) : null}
        <div className='text-right'>
          <Button
            variant='primary'
            className='mb-3'
            icon='fa-upload'
            onClick={this.handleShowUploadFile}
            type='button'
          >
            {get(msg, 'btnUploadCA')}
          </Button>
        </div>
        <LTEBox
          bodyComponent={
            <div>
              <ConfirmDialog
                id={confirmDeleteCA}
                onClickConfirm={this.handleDeleteClick}
                msg={msg.confirmDelete}
                btnConfirmVariant='primary'
                btnConfirmAccent='negative'
                btnCancelVariant='secondary'
                btnCancelAccent='positive'
              />
              {this.renderCA()}
            </div>
          }
          className='box box-primary'
          title={get(msg, 'boxTitle')}
        />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  ca: (state) => state.get('ca'),
});

function mapDispatchToProps(dispatch) {
  return {
    onShowWarning: (params) => dispatch(showWarning(params)),
    onDeleteCA: (params) => dispatch(deleteCA(params)),
    onPatchCA: (params) => dispatch(patchCA(params)),
    onUploadCA: (params) => dispatch(uploadCA(params)),
    onToggleConfirmDialog: () => dispatch(toggleConfirmDialog(confirmDeleteCA)),
    onShowUpload: (params) => dispatch(showUpload(params)),
  };
}

export default connectAsAny(
  mapStateToProps,
  mapDispatchToProps,
)(CertificationAuthorities);
